'use strict'

exports.Data = {
  SessionState: 'BotBuilder.Data.SessionState',
  SessionId: 'BotBuilder.Data.SessionId',
  Handler: 'BotBuilder.Data.Handler',
  Group: 'BotBuilder.Data.Group',
  Intent: 'BotBuilder.Data.Intent',
  WaterfallStep: 'BotBuilder.Data.WaterfallStep',
  Form: 'BotBuilder.Data.Form',
  Field: 'BotBuilder.Data.Field'
}

exports.DialogId = {
  Prompt: 'BotBuilder.Dialogs.Prompt',
  Field: 'BotBuilder.Dialogs.Field'
}

exports.Id = {
  DefaultGroup: 'BotBuilder.Id.DefaultGroup'
}

exports.Intents = {
  Default: 'BotBuilder.Intents.Default'
}
